import React from 'react';
import { ClipboardListIcon, HeartHandshakeIcon, MessageSquareQuoteIcon, HelpCircleIcon, WindIcon } from 'lucide-react';
const bonuses = [{
  icon: ClipboardListIcon,
  title: 'Beginner Pose Cheat Sheets',
  text: 'Quick-glance cues, common mistakes, and instant modifications — everything you need at a glance while you teach, without flipping through paragraphs mid-class.',
  price: '$19'
}, {
  icon: HeartHandshakeIcon,
  title: 'The New Student Welcome Kit',
  text: 'Everything you need to send, say, and hand a brand-new student — so they walk through the door already feeling like they belong. Ready-to-use templates, scripts, and forms.',
  price: '$27'
}, {
  icon: MessageSquareQuoteIcon,
  title: 'The Anti-Blank-Mind Script Vault',
  text: 'Ready-to-use phrases for the moments every new movement teacher fears most: the opening line, the mid-class pause, the mistake recovery, and the closing words.',
  price: '$36'
}, {
  icon: HelpCircleIcon,
  title: 'Common Questions & Objections Handbook',
  text: 'Every new teacher faces the same handful of questions — from nervous students deciding whether to book, and from colleagues questioning ready-made resources. Grounded, non-defensive answers you can use right away.',
  price: '$19'
}, {
  icon: WindIcon,
  title: 'Breath, Calm & Your First Students Toolkit',
  text: 'Two toolkits, one purpose: dependable tools beyond pose-teaching. Part One: 5 ready-to-use breath scripts. Part Two: bios, class descriptions, social posts & referral scripts.',
  price: '$27'
}];
export function Bonuses() {
  return <section className="w-full bg-cream-deep px-5 py-16 sm:py-24" data-id="element-48" data-mp="38e5sresxsrjk">
      <div className="mx-auto max-w-5xl" data-id="element-49" data-mp="33ge3ytnl9ljl">
        <h2 className="text-center text-2xl font-extrabold tracking-tight text-teal sm:text-4xl" data-id="element-50" data-mp="33jiee8rnddip">
          <span aria-hidden="true" data-id="element-51" data-mp="nrukkm7xk144">🎁</span> 5 Exclusive Bonuses
        </h2>
        <p className="mt-4 text-center text-base font-semibold text-terracotta sm:text-lg" data-id="element-52" data-mp="iqopwiupm3ry">
          Valued at $128 USD — Included FREE Today
        </p>

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-53" data-mp="3hh81f1j81w1w">
          {bonuses.map(({
          icon: Icon,
          title,
          text,
          price
        }, index) => <article key={title} className={`flex flex-col rounded-4xl border border-sage/25 bg-cream-card p-7 sm:p-8 ${index === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-54" data-mp="3lk4bg3up4ju8" data-mpi={index}>
              <div className="flex items-start justify-between gap-4" data-id="element-55" data-mp="2xtqtj65ts1dd">
                <span className="flex h-12 w-12 flex-none items-center justify-center rounded-2xl bg-sage-tint" data-id="element-56" data-mp="2xrxizfs3cx03">
                  <Icon className="h-5 w-5 text-teal" aria-hidden="true" data-id="element-57" data-mp="37jtjsylkb180" />
                </span>
                <p className="flex items-baseline gap-2 whitespace-nowrap" data-id="element-58" data-mp="2a4fq1gx3bsvj">
                  <span className="text-sm text-ink-soft line-through" data-id="element-59" data-mp="2a460tvjvdpqw">{price}</span>
                  <span className="rounded-full bg-gold px-3 py-1 text-xs font-bold uppercase tracking-[0.1em] text-ink" data-id="element-60" data-mp="2f1y2hhabgq8a">
                    Free
                  </span>
                </p>
              </div>
              <h3 className="mt-5 text-lg font-bold leading-snug text-teal" data-id="element-61" data-mp="22lpwmyuoc8hv">{title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-62" data-mp="1xk90fgn4xa7m">{text}</p>
            </article>)}
        </div>
      </div>
    </section>;
}